(function recipeherosliderScript($, Drupal) {
  Drupal.behaviors.recipeheroslider = {
    attach: function (context, settings) {
        $('.slick-slider-hero').slick({
            autoplay: true,
            autoplaySpeed: 2000,
            // cssEase: 'linear',
            dots: true,
            fade: true,
            infinite: true,
            slidesToScroll: 1,
            slidesToShow: 1,
            speed: 900,
            arrows : false
        });
    },
  };
}(jQuery, Drupal));
